/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type InteractionLabelFilterConfigColumn =
  (typeof InteractionLabelFilterConfigColumn)[keyof typeof InteractionLabelFilterConfigColumn];

export const InteractionLabelFilterConfigColumn = {
  interaction_label: 'interaction_label',
} as const;
